import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { mobile } from "../../utilities/detection";
import DesktopContent from "./DesktopContent";
import MobileContent from "./mobileContent";
import PreContentVideo from "../ads/preContentVideo";
import AdblockContentMessage from "../global/adblockContentMessage";
import { getString } from "../../utilities";
import Trouble from "./trouble";
import { fullScreen, gameCanPlay } from "../../utilities/games";
import Close from "../../../assets/svg/close.svg";
import { adsSelector } from "../../redux/slices/loginSlice";
import { fullScreenActiveSelector } from "../../redux/slices/userClientSlice";
import {
  preContentVideoSelector,
  clickToPlayVideoSelector,
  setPreContentVideo,
  setShouldReload,
} from "../../redux/slices/preContentVideoSlice";
import { contentAdTypes } from "../../config/constants";

export default function GameContent({ game, isGameFree, isArcademics, publicModalToggle }) {
  const prevGameShortname = useRef(null);
  const currGameShortname = useRef(null);
  const prevGameAdType = useRef(null);
  const currGameAdType = useRef(null);

  const fullScreenActive = useSelector(fullScreenActiveSelector);
  const preContentVideo = useSelector(preContentVideoSelector);
  const clickToPlayVideo = useSelector(clickToPlayVideoSelector);
  const dispatch = useDispatch();

  const ads = useSelector(adsSelector);

  const canPlayGame = gameCanPlay(isGameFree);

  useEffect(() => {
    if (game.shortname) {
      if (currGameShortname.current !== game.shortname) {
        prevGameShortname.current = currGameShortname.current;
        prevGameAdType.current = currGameAdType.current;

        currGameShortname.current = game.shortname;
        currGameAdType.current = game.adType;

        dispatch(
          setShouldReload({
            shouldReload: !prevGameShortname.current || currGameAdType.current !== prevGameAdType.current,
          }),
        );
      }

      dispatch(setPreContentVideo({ preContentVideo: !mobile && game.adType === contentAdTypes.preroll && ads }));
    }
  }, [ads, game]);

  const renderCloseFullButton = () => {
    if (fullScreenActive) {
      return (
        <a
          onClick={() => {
            fullScreen.exit();
          }}
          className="game-fullscreen-close"
          alt={getString("navigation.fullscreen.exit")}
        >
          <Close />
        </a>
      );
    }

    return null;
  };

  const renderContent = () => {
    if (mobile) {
      return (
        <MobileContent
          game={game}
          canPlayGame={canPlayGame}
          isArcademics={isArcademics}
          publicModalToggle={publicModalToggle}
        />
      );
    }

    if (preContentVideo && isGameFree) {
      return <PreContentVideo />;
    }
    return (
      <DesktopContent
        gameData={game}
        isArcademics={isArcademics}
        canPlayGame={canPlayGame}
        publicModalToggle={publicModalToggle}
      />
    );
  };

  let orientation = mobile && game.mobileOrientation ? game.mobileOrientation : game.orientation;

  if (["vertical", "portrait"].includes(orientation)) {
    orientation = "vertical";
  } else {
    orientation = "horizontal";
  }

  if (isArcademics) orientation = "arcademics";
  const containerStyle = fullScreenActive ? "game-container-fullscreen" : "container";

  const prerollStyle = isGameFree && (preContentVideo || clickToPlayVideo) ? "prerollvideo" : "";

  return (
    <div className="game-description-wrapper">
      {/* supplies the overall width */}
      <div className="game-game-wrapper">
        {/* supplies the overall height */}

        <div id="game-container" className={`game-game ${orientation} ${prerollStyle}`}>
          {/* supplies the variant widths */}

          <div id="desktopGame" className={containerStyle}>
            {/* provides aspect ratio */}

            {renderContent()}

            <AdblockContentMessage message={getString("adblock.content", { replace: [getString("game.title.0")] })} />

            {renderCloseFullButton(game)}
          </div>
        </div>
      </div>

      <div className="description">
        <p className="description-text">{game?.description}</p>

        <Trouble isGameFree={isGameFree} gameData={game ? { label: game.fullname, value: game.id } : null} />
      </div>
    </div>
  );
}
